import React from "react";
import Text from "@/components/ui/text";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { ViewDataConfiguration } from "@/entities/views/types";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  view: ViewDataConfiguration | null;
  onDelete: () => void;
}

const DeleteViewModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  view,
  onDelete
}) => {
  const { t } = useTranslation();

  if (!view) return null;

  return (
    <Modal
      open={isOpen}
      setIsOpen={setIsOpen}
      contentClassname="w-[35rem]"
      title={
        <Text as="div" variant="lgSubtitleH1">
          {t("datatoolbar.views.delete.title")}
        </Text>
      }
      content={
        <div className="flex flex-col gap-3 h-fit w-[35rem] p-4">
          <Text as="div" variant="body">
            {t("datatoolbar.views.delete.confirmation", {
              viewName: view.name
            })}
          </Text>
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            data-test="cancel-delete-view"
            variant="secondary"
            onClick={() => setIsOpen(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            data-test="confirm-delete-view"
            destructive
            onClick={onDelete}
          >
            {t("delete")}
          </Button>
        </div>
      }
    />
  );
};

export default DeleteViewModal;
